import Render from 'common/Render';
import makeRoutes from './routes';
import _debug from 'debug';

const debug = _debug('app::tip');

export function edit(ctx) {
  const id = ctx.params.id;
  if (id) {
    debug(`Rendering technical tip ${id}`);

    Render.render(store => makeRoutes(store, id));
  }
}



// WEBPACK FOOTER //
// ./src/modules/tip/index.js